import { useQuery, useReactiveVar } from "@apollo/client";
import { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import mixpanel from "mixpanel-browser";

import { GET_HOME_PARENT_INFO } from "../../api/gqlQueries";
import Spinner from "../Spinner";
import {
  BrilliantDeviceTypes,
  IHomeParentInfo,
} from "../../interfaces/interfaces";
import {
  organizationIdNameVar,
  smallHeaderBackArrow,
  smallHeaderTitle,
  userIdVar,
} from "../apollo/LocalState";
import Breadcrumbs from "../breadcrumbs/Breadcrumbs";

import ControlDetails from "./ControlDetails";
import SwitchDetails from "./SwitchDetails";
import PlugDetails from "./PlugDetails";

const DeviceDetails: React.FC = () => {
  const organizationIdName = useReactiveVar(organizationIdNameVar);
  const params = useParams();
  let { propertyId, deviceId } = params;
  if (!propertyId || !deviceId) {
    propertyId = "";
    deviceId = "";
  }
  const [searchParams] = useSearchParams();
  const deviceType = searchParams.get("device_type");
  const [deviceName, setDeviceName] = useState("");
  const userId = useReactiveVar(userIdVar);
  const { data: homeParentData, loading } = useQuery<IHomeParentInfo>(
    GET_HOME_PARENT_INFO,
    {
      variables: { propertyId },
    }
  );
  useEffect(() => {
    window.scrollTo(0, 0);
    mixpanel.track("Device Details Viewed", {
      device_id: deviceId,
      organization_id: organizationIdName.organizationId,
      property_id: propertyId,
      user_id: userId,
    });
  }, []);
  useEffect(() => {
    window.scrollTo(0, 0);
    smallHeaderTitle(deviceName);
    smallHeaderBackArrow(true);
    return () => {
      smallHeaderTitle("");
      smallHeaderBackArrow(false);
    };
  }, [deviceName]);
  if (loading) return <Spinner />;
  if (!homeParentData) return <div>No data was returned</div>;

  const regionLink = `/${organizationIdName.organizationId}/homes/${homeParentData.home.parentProperties[0].propertyId}`;
  const homeLink = `/${organizationIdName.organizationId}/home/${homeParentData.home.id}`;
  const crumbs = [
    {
      name: organizationIdName.organizationName,
      path: `/${organizationIdName.organizationId}/organization`,
    },
    {
      name: "Home",
      path: regionLink,
    },
    {
      name: homeParentData?.home.propertyName,
      path: homeLink,
    },
    {
      name: deviceName,
      path: "",
    },
  ];
  return (
    <div className="center-align-as-column">
      <div className="device-details-container-main">
        <Breadcrumbs
          crumbs={crumbs}
          rootCrumb={{ name: "Organizations", path: "/" }}
        />
        {deviceType === BrilliantDeviceTypes.CONTROL && (
          <ControlDetails
            setDeviceName={setDeviceName}
            deviceId={deviceId}
            propertyId={propertyId}
          />
        )}
        {deviceType === BrilliantDeviceTypes.SWITCH && (
          <SwitchDetails
            deviceId={deviceId}
            propertyId={propertyId}
            setDeviceName={setDeviceName}
          />
        )}
        {deviceType === BrilliantDeviceTypes.PLUG && (
          <PlugDetails
            deviceId={deviceId}
            propertyId={propertyId}
            setDeviceName={setDeviceName}
          />
        )}
      </div>
    </div>
  );
};

export default DeviceDetails;
